/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-12 08:59:52
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-11-18 13:38:51
 */
import { API_URL } from '@/api/url';
import { Http } from '@/lib/http';

export class DlBillApi {
  /**
   * 查询账单
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768845
   */
  static getBillList = (params: any) => {
    return Http({
      method: 'GET',
      url: API_URL.GetBillList,
      params
    });
  };

  /**
   * 导出订单汇总
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768851
   */
  static exportBill = (params: any) => {
    return Http({
      method: 'GET',
      url: API_URL.ExportBill,
      params
    });
  };

  /**
   * 导出订单详情
   * @link mock地址 https://mock.xiaojukeji.com/project/7211/interface/api/768857
   */
  static exportOrder = (params: any) => {
    return Http({
      method: 'GET',
      url: API_URL.ExportOrder,
      params
    });
  };
}
